import React, { FC } from 'react'
import isEmpty from 'lodash/isEmpty'
import { Typography } from 'react-components'
import { OwnerInfoWrapper, OwnerInfoContent, OwnerDetails, QuickResponderTag, StyledFastResponderIcon } from './styles'
import { FormattedContactDetails } from '../../../../models/property-details-page/contact-model'
import get from 'lodash/get'
import { PropertyDetails } from '../../../../transports/property-details-page-transport'
import OwnerImage from '../../contact/owner-image'
import { useTranslation } from '../../../../hooks/locale'
import { useABVariant } from '../../../../utils/hooks'
import { AB_KEY, AB_VARIANT_VERSION } from '../../../../common/constants'
import { FormattedBookingTypeData } from '../../../../models/property-details-page/booking-type-model'

export interface ContactProps {
    contact?: FormattedContactDetails
    trust?: Record<string, string | null>
    providerId: PropertyDetails['providerId']
    responseTimeAverage?: number
    bookingType: FormattedBookingTypeData | null
}

const OwnerInfo: FC<ContactProps> = ({ contact, trust = [], providerId, responseTimeAverage, bookingType }) => {
    const { t } = useTranslation()
    const { isProvidedVariantActive } = useABVariant(AB_KEY.SUPERFAST_RESPONDER_TAG, AB_VARIANT_VERSION.ONE)
    const isFastResponder =
        responseTimeAverage !== undefined &&
        responseTimeAverage &&
        responseTimeAverage <= 43_200 &&
        isProvidedVariantActive

    const isDirectBooking = get(bookingType, 'type') === 'direct_booking' && isEmpty(get(bookingType, 'subType.type'))

    return (
        <OwnerInfoWrapper>
            <OwnerInfoContent>
                <OwnerImage
                    imageUrl={contact?.photo}
                    name={contact?.name}
                    providerId={providerId}
                    gender={contact?.gender}
                    borderRadius={'50%'}
                    height={'4.5rem'}
                    width={'4.5rem'}
                />
                <OwnerDetails>
                    {(isDirectBooking || !isEmpty(contact?.name)) && (
                        <Typography variant="button" fontWeight="semiBold">
                            {isDirectBooking ? t('contact.contactAgencyGenericName') : contact?.name}
                        </Typography>
                    )}
                    {!isEmpty(get(trust, 'onlineSince')) && (
                        <Typography variant="button" color="tfwBlack40">
                            {get(trust, 'onlineSince')}
                        </Typography>
                    )}
                    {isFastResponder && (
                        <QuickResponderTag>
                            <StyledFastResponderIcon /> {t('quickResponderText')}
                        </QuickResponderTag>
                    )}
                </OwnerDetails>
            </OwnerInfoContent>
        </OwnerInfoWrapper>
    )
}

export default OwnerInfo
